import { OnlinePaymentOptionsResource } from "@/interfaces";

/**
 * Why a plan has no instalments to list, in the API's own words. It refuses to schedule
 * a contract with nothing left to pay, one too old or in a status that takes no
 * payment, and says why in `message`. Without it the customer saw only "no payments to
 * display", above a Confirm button that could only be refused.
 */
export const emptyScheduleReason = (
  meta?: Pick<OnlinePaymentOptionsResource["meta"], "can_pay" | "message">
): string | null => (meta?.can_pay === false && meta.message ? meta.message : null);
